import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import Typography from '@material-ui/core/Typography'
import useStyles from './stylesSkeleton'

const SkeletonItem = ({ hasCheckbox = true }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {hasCheckbox ? (
        <div className={classes.itemCheckboxWrapper}>
          <Skeleton
            className={classes.itemCheckbox}
            variant="circle"
            width={16}
            height={16}
          />
        </div>
      ) : null}
      <Typography component="div" variant="body2" className={classes.itemText}>
        <Skeleton />
      </Typography>
      <div className={classes.itemActions}>
        <Skeleton
          className={classes.itemIcon}
          variant="circle"
          width={16}
          height={16}
        />
        <Skeleton
          className={classes.itemIcon}
          variant="circle"
          width={16}
          height={16}
        />
      </div>
    </div>
  )
}

export default SkeletonItem
